import { highScoreList } from "@/mocks/manhwa";

export default function HighScore() {
  return (
    <section id="highscore" className="bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-medium text-accent-700">
            <i className="ri-award-line"></i> 口碑之作
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black text-foreground-900 md:text-4xl">
            好看的韩国漫画评分高 · 高分神作榜
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            评分是检验一部作品最诚实的标准。这里的每一部，都是经过海量读者验证、评分长期居高不下的高分神作。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {highScoreList.map((item) => (
            <article
              key={item.title}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:shadow-md"
            >
              <div className="relative">
                <img
                  src={item.cover}
                  alt={`${item.title} 韩国漫画评分高封面`}
                  className="aspect-[7/10] w-full object-cover object-top"
                />
                <span className="absolute right-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-sm font-bold text-background-50">
                  {item.score.toFixed(1)} 分
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base font-bold text-foreground-900 md:text-lg">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{item.author} · {item.genre}</p>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-700 md:text-sm">{item.desc}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {item.tags.map((tag) => (
                    <span key={tag} className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}